import requestService from '~/services/requestsService';
import { ImageUploadType } from '@bitecritic-api/src/images/images.service';
import { ImagesEntity } from '@bitecritic-api/src/images/images.zod';

const BASE_IMAGES = '/images';

const uploadImage = async (formData: FormData, type: ImageUploadType) => {
  formData.append('type', type);
  return requestService.post<ImagesEntity>(`${BASE_IMAGES}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const deleteImage = (imageId: string) => {
  return requestService.delete(`${BASE_IMAGES}/${imageId}`);
};

const imagesService = {
  uploadImage,
  deleteImage,
};

export default imagesService;
